import { createAsyncTypes } from 'utils/ActionCreator'

export const INSIGHT_WIDGET_REQUEST_ASYNC = createAsyncTypes(
  'INSIGHT_WIDGET_REQUEST_ASYNC',
  'IronScales/Dashboard/Home/InsightWidget'
)

export const INSIGHT_THREAT_TYPES_REQUEST_ASYNC = createAsyncTypes(
  'INSIGHT_THREAT_TYPES_REQUEST_ASYNC',
  'IronScales/Dashboard/Home/InsightWidget/ThreatTypes'
)
